var _pattern, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomPatternCircleLeftDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 450,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "polkaDots",
    patternUnits: "userSpaceOnUse",
    width: 15,
    height: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 1,
    fill: "#0060ff"
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fadeGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "white",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    style: {
      stopColor: "white",
      stopOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "white",
      stopOpacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    style: {
      stopColor: "white",
      stopOpacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90%",
    style: {
      stopColor: "white",
      stopOpacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "white",
      stopOpacity: 0
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 450,
    height: 450,
    fill: "url(#polkaDots)",
    mask: "url(#fadeMask)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomPatternCircleLeftDots);
export default __webpack_public_path__ + "static/media/custom-pattern-circle-left-dots.6a1dff3dc387bf56565cfc812979ac5a.svg";
export { ForwardRef as ReactComponent };